(function() {
    const box = document.getElementById('main-content');
    let isMobile = /android|iphone|ipad|ipod|micromessenger/gi.test(navigator.userAgent.toLocaleLowerCase()) || window.innerWidth <= 1000;

    function getNodeList(node) {

        var list = Array.prototype.slice.call(node.querySelectorAll('[node-name]'), 0);
        var nodeList = {};

        list.forEach(function(el) {
            var name = el.getAttribute('node-name');

            if (name in nodeList) {
                nodeList[name] = [].concat(nodeList[name], el);
            } else {
                nodeList[name] = el;
            }
        });

        return nodeList;
    }

    function getOffset(el) {
        let box = el.getBoundingClientRect();
        let body = document.body;
        let clientTop = el.clientTop || body.clientTop || 0;
        let clientLeft = el.clientLeft || body.clientLeft || 0;
        let scrollTop = window.scrollY || el.scrollTop;
        let scrollLeft = window.scrollX || el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft,
            scrollTop,
            scrollLeft
        };
    }

    let screenHeight = window.innerHeight;
    let screenWidth = window.innerWidth;

    let nodeList = getNodeList(box);
    console.log(nodeList);

    let offsetMap = {};

    document.addEventListener('scroll', function() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        runSixthAnime(scrollTop);
        playVideo(scrollTop);
    }, { passive: true });

    let _timer = null;
    window.addEventListener('resize', function() {
        clearTimeout(_timer);
        _timer = setTimeout(() => {
            isMobile = /android|iphone|ipad|ipod|micromessenger/gi.test(navigator.userAgent.toLocaleLowerCase()) || screenWidth <= 1000;
            initOffset();
            loadSeventh();
        }, 100);
    });

    // 初始化偏移量
    function initOffset() {
        if (nodeList.sixthMenus) {
            offsetMap.sixth = {
                menus: nodeList.sixthMenus,
                menu: nodeList.sixthMenu,
                slide: nodeList.sixthSlide,
                top: getOffset(nodeList.sixthSection).top,
                height: nodeList.sixthSection.offsetHeight,
                videos: isMobile ? nodeList.mobileSixVideo : nodeList.pcSixVideo
            };
        }

        if (nodeList.seventhItems) {
            offsetMap.seventh = {
                width: nodeList.seventhItems.scrollWidth,
                box: nodeList.seventhItems,
                card: nodeList.seventhCard,
                slide: nodeList.seventhSlide,
                prev: nodeList.seventhPrev,
                next: nodeList.seventhNext,
                cardWidth: nodeList.seventhCard[0].offsetWidth + 20,
                cardLeft: isMobile ? nodeList.seventhCard.map(node => getOffset(node).left) : []
            };
        }

        const videoList = [];
        const list = [].concat(isMobile ? nodeList.mobileVideo : nodeList.pcVideo);
        list.forEach(node => {
            if (node) {
                videoList.push({
                    node,
                    play: false,
                    top: getOffset(node).top
                });
            }
        });

        offsetMap.videoList = videoList;
        screenHeight = window.innerHeight;
        screenWidth = window.innerWidth;
    }

    // 播放视频
    function playVideo(scrollTop) {
        const list = offsetMap.videoList;
        if (list && list.length > 0) {
            list.forEach((obj, i) => {
                if (i > 0) {
                    return false;
                }
                if (!obj.play
                    && scrollTop + screenHeight > obj.top
                    && scrollTop - screenHeight < obj.top
                ) {
                    obj.node.play();
                    obj.play = true;
                } else if (obj.play && (scrollTop > obj.top + screenHeight || scrollTop + screenHeight < obj.top)) {
                    obj.node.pause();
                    obj.play = false;
                }
            });
        }
    }

    initOffset();

    // 获取滑动比例
    function getMoveRate(scrollTop, top, height) {
        return Math.round(Math.min(1, Math.max(0, scrollTop - top) / (height - screenHeight)) * 100);
    }

    // 视频播放处理
    let isClickPlay = false;
    nodeList.play && nodeList.play.addEventListener('click', function() {
        offsetMap.videoList[1].node.play();
        offsetMap.videoList[1].play = true;
        offsetMap.videoList[1].node.parentNode.classList.add('play');
        offsetMap.videoList[0].node.pause();
        offsetMap.videoList[0].play = false;
        isClickPlay = true;
        nodeList.play.removeEventListener('click', arguments.callee);
    });

    nodeList.videoPlayer && nodeList.videoPlayer.forEach((node, index) => {
        node.addEventListener('mouseenter', function() {
            if (index === 0 || isClickPlay) {
                offsetMap.videoList[index].node.controls = true;
            }
        });

        node.addEventListener('mouseleave', function() {
            offsetMap.videoList[index].node.controls = false;
        });
    });

    nodeList.pcVideo && nodeList.pcVideo.forEach((node, index) => {
        node.addEventListener('play', function() {
            offsetMap.videoList[index].play = true;
            let next = 0;
            if (index === 0) {
                next = 1;
            }
            offsetMap.videoList[next].node.pause();
            offsetMap.videoList[next].play = false;
        });
    });

    nodeList.mobileVideo && nodeList.mobileVideo.forEach((node, index) => {
        node.addEventListener('play', function() {
            offsetMap.videoList[index].play = true;
            let next = 0;
            if (index === 0) {
                next = 1;
            }
            offsetMap.videoList[next].node.pause();
            offsetMap.videoList[next].play = false;
        });
    });

    // 第六屏动画
    let sixthSelect = 0;

    function setSixthGradual(index) {
        const obj = offsetMap.sixth;
        if (!obj) {
            return false;
        }
        switch (index) {
            case 0:
                obj.menu[0].style.backgroundImage = '';
                obj.menu[1].style.backgroundImage = 'linear-gradient(rgba(86, 86, 86, 0.75), rgba(86, 86, 86, 0.55))';
                obj.menu[2].style.backgroundImage = 'linear-gradient(rgba(86, 86, 86, 0.5), rgba(86, 86, 86, 0.3))';
                obj.menu[3].style.backgroundImage = 'linear-gradient(rgba(86, 86, 86, 0.25), rgba(86, 86, 86, 0.05))';
                break;
            case 1:
                obj.menu[1].style.backgroundImage = '';
                obj.menu[0].style.backgroundImage = 'linear-gradient(rgba(86, 86, 86, 0.55), rgba(86, 86, 86, 0.75))';
                obj.menu[2].style.backgroundImage = 'linear-gradient(rgba(86, 86, 86, 0.75), rgba(86, 86, 86, 0.55))';
                obj.menu[3].style.backgroundImage = 'linear-gradient(rgba(86, 86, 86, 0.5), rgba(86, 86, 86, 0.3))';
                break;
            case 2:
                obj.menu[2].style.backgroundImage = '';
                obj.menu[1].style.backgroundImage = 'linear-gradient(rgba(86, 86, 86, 0.55), rgba(86, 86, 86, 0.75))';
                obj.menu[0].style.backgroundImage = 'linear-gradient(rgba(86, 86, 86, 0.3), rgba(86, 86, 86, 0.5))';
                obj.menu[3].style.backgroundImage = 'linear-gradient(rgba(86, 86, 86, 0.75), rgba(86, 86, 86, 0.55))';
                break;
            case 3:
                obj.menu[3].style.backgroundImage = '';
                obj.menu[2].style.backgroundImage = 'linear-gradient(rgba(86, 86, 86, 0.55), rgba(86, 86, 86, 0.75))';
                obj.menu[1].style.backgroundImage = 'linear-gradient(rgba(86, 86, 86, 0.3), rgba(86, 86, 86, 0.5))';
                obj.menu[0].style.backgroundImage = 'linear-gradient(rgba(86, 86, 86, 0.05), rgba(86, 86, 86, 0.25))';
                break;
        }
    }

    nodeList.sixthMenus && nodeList.sixthMenus.addEventListener('click', ev => {
        const height = offsetMap.sixth.height;
        const top = offsetMap.sixth.top;
        const mod = height / 3;
        const index = ev.target.dataset.key;
        console.log(ev.target, index);
        if (index) {
            window.scrollTo(0, top + mod * index - (index > 0 ? 10 : -10));
        }
    });

    function runSixthAnime(scrollTop) {
        if (!offsetMap.sixth) {
            return false;
        }
        const obj = offsetMap.sixth;
        const rate = getMoveRate(scrollTop, obj.top, obj.height);
        let select = 0;
        if (rate < 33.3) {
            select = 0;
        } else if (rate < 66.6) {
            select = 1;
        } else {
            select = 2;
        }

        if (scrollTop - obj.top + screenHeight / 2 > 0 && select === 0) {
            obj.videos[0].play();
        }

        if (sixthSelect !== select) {
            obj.menu[sixthSelect].classList.remove('selected');
            obj.menu[select].classList.add('selected');
            obj.slide[sixthSelect].classList.remove('show');
            obj.slide[select].classList.add('show');
            sixthSelect = select;
            // setSixthGradual(select);
            obj.videos.forEach(video => {
                video.pause();
            });
            obj.videos[select].play();
        }
    }

    // setSixthGradual(0);


    // 第七屏处理
    let sevenObj = {
        prev: false,
        next: true
    };

    function loadSeventh() {
        if (!nodeList.seventhSlide) {
            return false;
        }
        const obj = offsetMap.seventh;
        // 显示前后按钮
        nodeList.seventhSlide.style.display = 'none';
        if (!isMobile && obj.width > screenWidth + 20) {
            nodeList.seventhSlide.style.display = 'flex';
        }
    }

    loadSeventh();

    nodeList.seventhSlide && nodeList.seventhSlide.addEventListener('click', function(ev) {
        const node = ev.target;
        const index = node.dataset.key;
        if (index) {
            if (node.classList.contains('gray')) {
                return false;
            }

            const obj = offsetMap.seventh;
            const run = function(current, max, progress, type) {
                setTimeout(() => {
                    if (type === 0) {
                        obj.box.scrollLeft = current - Math.min(max, progress);
                    } else {
                        obj.box.scrollLeft = current + Math.min(max, progress);
                    }

                    if (progress < max) {
                        run(current, max, progress + 20, type);
                    }
                }, 10);
            };

            if (Number(index) === 0) {
                run(obj.box.scrollLeft, obj.cardWidth, 20, 0);
            } else {
                run(obj.box.scrollLeft, obj.cardWidth, 20, 1);
            }
        }
    });

    let seventhNode = offsetMap.seventh ? offsetMap.seventh.card[0] : null;
    nodeList.seventhItems && nodeList.seventhItems.addEventListener('scroll', function(ev) {
        const obj = offsetMap.seventh;
        const left = ev.target.scrollLeft;

        if (isMobile) {
            obj.cardLeft.forEach((x, i) => {
                if (x - left >= 0 && x + obj.cardWidth <= left + screenWidth + 20) {
                    if (seventhNode !== obj.card[i]) {
                        seventhNode && seventhNode.classList.remove('hover');
                        seventhNode = obj.card[i];
                        seventhNode.classList.add('hover');
                    }
                }
            });

            return false;
        }

        if (left < 10 && sevenObj.prev) {
            sevenObj.prev = false;
            obj.prev.classList.add('gray');
        } else if (left >= 10 && !sevenObj.prev) {
            sevenObj.prev = true;
            obj.prev.classList.remove('gray');
        }

        if (left > obj.width - screenWidth - 10 && sevenObj.next) {
            sevenObj.next = false;
            obj.next.classList.add('gray');
        } else if (left <= obj.width - screenWidth - 10 && !sevenObj.next) {
            sevenObj.next = true;
            obj.next.classList.remove('gray');
        }
    });

    // 第八屏动画
    if (nodeList.eighthCard) {
        nodeList.hoverTips.innerHTML = nodeList.cardMsg[0].innerHTML;
        nodeList.eighthCard.forEach((node, i) => {
            node.addEventListener('mouseenter', function() {
                if (!isMobile) {
                    nodeList.eighthCard.forEach(n => {
                        n.classList.remove('hover');
                    });
                    node.classList.add('hover');
                    nodeList.hoverTips.innerHTML = nodeList.cardMsg[i].innerHTML;
                }
            });

            node.addEventListener('click', function() {
                if (isMobile) {
                    nodeList.eighthCard.forEach(n => {
                        n.classList.remove('hover');
                    });
                    node.classList.add('hover');
                    nodeList.hoverTips.innerHTML = nodeList.cardMsg[i].innerHTML;
                }
            });
        });
    }
})();